import Vue from 'vue'
import {join, map, pipe} from 'ramda'
import {getFullName} from '@/helpers/utils'

Vue.filter('pluckFullName', function(value) {
  return pipe(map(getFullName), join(', '))(value)
})
